import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {convertPhase} from "../../../core/utils/phase.utils";
import {MatTab, MatTabGroup, MatTabLabel} from "@angular/material/tabs";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
    selector: 'app-moon',
    templateUrl: './moon.component.html',
    imports: [
        MatTabGroup,
        MatTab,
        TranslatePipe,
        MatTabLabel
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./moon.component.scss']
})
export class MoonComponent implements OnInit {

    phaseTabIndex = 0;

    phases: string [] = ["0", "1", "4", "5"]

    constructor(
        @Inject(MAT_DIALOG_DATA) public phaseId: string
    ) {
    }

    ngOnInit(): void {
        this.initActiveTab();
    }

    private initActiveTab() {
        const converted = convertPhase(this.phaseId)
        this.phaseTabIndex = this.phases.indexOf(converted, 0)
    }
}